import React from "react";
import Hero from "../common/Hero";

interface OrganizationHeroProps {
  name: string;
  description?: string;
  logo?: string;
  heroImage?: string;
  height?: "small" | "medium" | "large";
}

const OrganizationHero: React.FC<OrganizationHeroProps> = ({
  name,
  description,
  logo,
  heroImage,
  height = "large",
}) => (
  <Hero
    title={name}
    subtitle={description ?? ""}
    backgroundImage={heroImage ?? logo ?? ""}
    height={height}
  />
);

export default OrganizationHero;
